export const mobile = 576;
export const tablet = 768;
export const desktopMD = 992;
export const desktopLG = 1200;
export const desktopXL = 1400;

